// extracted by mini-css-extract-plugin
module.exports = {"deleteRow":"CarCard_deleteRow__2kxb0","deleteIcon":"CarCard_deleteIcon__1aftL"};